export const Programs = [
"UHS2",
"UHS2 with ACSM",
"UHS4",
"UHS4 with ACSM",
"ES1",
"ES2",
"ES3",
"HL 200",
"HL 200 with ACSM",
"HL 400",
"HL 600",
"STx2",
"CHS200",
];